import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import * as PropTypes from "prop-types";


const root = ReactDOM.createRoot(document.getElementById('root'));

function Routes(props) {
    return null;
}

Routes.propTypes = {children: PropTypes.node.js};
root.render(
  <React.StrictMode>
        <App/>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
